export default "/images/expiry.png?193745eb29388e301db64af89d025f61";